import { styled } from 'styled-components';

export const ButtonWrapper = styled.button`
  display: block;
  text-align: inherit;
  width: 100%;
`;
